import { useState } from 'react';
import { LibraryItem } from '../components/library-list/types';
import { deleteDocumentTemplate } from '../../../slices/document-templates/documentTemplatesSlice';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { useErrorMessage } from '../../../common/hooks/useErrorMessage';

export const useDeleteLibraryItemMessageModal = () => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectUser);
  const { getErrorMessage } = useErrorMessage();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [libraryItemToDelete, setLibraryItemToDelete] = useState<LibraryItem | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);

  const handleDeleteDocumentTemplate = () => {
    setPendingStatus(true);
    setModalOpen(false);
    dispatch(
      deleteDocumentTemplate({ id: libraryItemToDelete?.id as number, userId: currentUser.id })
    )
      .unwrap()
      .then(() => {
        if (id) {
          navigate(ROUTES.DOCUMENT_LIBRARY);
        }
      })
      .catch((error) => {
        toast.error(getErrorMessage(error));
      })
      .finally(() => {
        setLibraryItemToDelete(null);
        setModalOpen(false);
        setPendingStatus(false);
      });
  };

  return {
    modalOpen,
    setModalOpen,
    libraryItemToDelete,
    setLibraryItemToDelete,
    pendingStatus,
    handleDeleteDocumentTemplate,
  };
};
